import { render, staticRenderFns } from "./instance-index-service-config-form.view.vue?vue&type=template&id=0ddadf2f&scoped=true"
import script from "./instance-index-service-config-form.view.vue?vue&type=script&lang=ts"
export * from "./instance-index-service-config-form.view.vue?vue&type=script&lang=ts"
import style0 from "./instance-index-service-config-form.view.vue?vue&type=style&index=0&id=0ddadf2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddadf2f",
  null
  
)

export default component.exports